// src/services/streakService.ts
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db, appId } from '../firebase'; // firebase.ts のパスが正しいことを確認
import dayjs from 'dayjs';

export const updateCompletionDateList = async (userId: string) => {
    const today = dayjs().format('YYYY-MM-DD');
    const ref = doc(db, `artifacts/${appId}/users/${userId}/userData`, 'ChallengeQuizSelection');
    const snap = await getDoc(ref);
    const data = snap.exists() ? snap.data() : {};

    const prevDate = data.lastCompletionDate;
    let streakDays = data.streakDays || 0;

    const diff = prevDate ? dayjs(today).diff(dayjs(prevDate), 'day') : null;

    if (diff === 1) {
        streakDays += 1;
    } else if (diff === 0) {
        // 同日：更新不要
        return;
    } else {
        // 2日以上空いたら streak リセット
        streakDays = 1;
    }

    const prevList: string[] = Array.isArray(data.completionDateList) ? data.completionDateList : [];
    const mergedList = [...new Set([...prevList, today])]
        .filter(date => dayjs(date, 'YYYY-MM-DD', true).isValid())
        .sort((a, b) => dayjs(b).valueOf() - dayjs(a).valueOf())
        .slice(0, 31);

    await setDoc(ref, {
        streakDays,
        lastCompletionDate: today,
        completionDateList: mergedList
    }, { merge: true });
};